<template>

  <section

    id="section-home"

    class="hero-section"

    @mouseenter="stopSlider"

    @mouseleave="startSlider"

  >

    <div class="hero-section__slides" aria-hidden="true">

      <div

        ref="track"

        class="hero-section__track"

        :class="{ 'hero-section__track--instant': noTransition }"

        :style="trackStyle"

        @transitionend="onTrackTransitionEnd"

      >

        <div

          v-for="(src, index) in trackSlides"

          :key="`hero-${slideKey}-${index}`"

          class="hero-section__slide"

        >

          <img :src="src" alt="" loading="eager" decoding="async">

        </div>

      </div>

    </div>

  </section>

</template>

<script>

import { mapState } from 'vuex'
import { resolveHeroSlides } from '@/utils/heroSlides'

const SLIDE_INTERVAL_MS = 3200

const SLIDE_DURATION_MS = 520

export default {

  name: 'BlackGoldHero',

  data () {
    return {

      currentIndex: 0,

      noTransition: false,

      isSnapping: false,

      slideTimer: null,

      slideKey: 0

    }
  },

  computed: {

    ...mapState({
      bannerList: state => state.bannerList
    }),

    heroSlides () {
      return resolveHeroSlides(this.bannerList, this.$i18n.locale)
    },

    slideCount () {
      return this.heroSlides.length
    },

    trackSlides () {
      return [...this.heroSlides, ...this.heroSlides]
    },

    trackStyle () {
      return {

        transform: `translate3d(-${this.currentIndex * 100}%, 0, 0)`,

        transitionDuration: `${SLIDE_DURATION_MS}ms`

      }
    }

  },

  watch: {

    '$i18n.locale' () {
      this.resetSlider()
    }

  },

  mounted () {
    this.startSlider()
  },

  beforeDestroy () {
    this.stopSlider()
  },

  methods: {

    resetSlider () {
      this.stopSlider()

      this.currentIndex = 0

      this.isSnapping = false

      this.noTransition = true

      this.slideKey += 1

      this.$nextTick(() => {
        const track = this.$refs.track

        if (track) {
          void track.offsetHeight
        }

        window.requestAnimationFrame(() => {
          this.noTransition = false

          this.startSlider()
        })
      })
    },

    startSlider () {
      this.stopSlider()

      this.slideTimer = window.setInterval(this.nextSlide, SLIDE_INTERVAL_MS)
    },

    stopSlider () {
      if (this.slideTimer) {
        window.clearInterval(this.slideTimer)

        this.slideTimer = null
      }
    },

    nextSlide () {
      if (this.isSnapping || this.noTransition) return

      this.currentIndex += 1

      if (this.currentIndex === this.slideCount && this.prefersReducedMotion()) {
        this.snapToStart()
      }
    },

    prefersReducedMotion () {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches
    },

    snapToStart () {
      this.isSnapping = true

      this.noTransition = true

      this.currentIndex = 0

      this.$nextTick(() => {
        const track = this.$refs.track

        if (track) {
          void track.offsetHeight
        }

        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            this.noTransition = false

            this.isSnapping = false
          })
        })
      })
    },

    onTrackTransitionEnd (event) {
      if (event.propertyName !== 'transform') return

      if (event.target !== this.$refs.track) return

      if (this.currentIndex !== this.slideCount) return

      this.snapToStart()
    }

  }

}

</script>
